<template>
  <MainLayout>
    <v-container class="mt-10">
      <v-row>
        <v-breadcrumbs :items="breadcrumbs">
          <template v-slot:prepend>
            <v-icon icon="$vuetify" size="small"></v-icon>
          </template>
        </v-breadcrumbs>
        <v-divider></v-divider>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="showAddColorDialog" color="primary float-right"
            >Renk Talep Et</v-btn
          >
          <!-- Kullanıcı Ekle Butonu -->
        </v-col>
      </v-row>

      <v-dialog v-model="addColorDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Renk Talep Et</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                v-model="newColor.name"
                label="Ad"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="addColor">Ekle</v-btn>
            <v-btn color="grey" text @click="addColorDialog = false"
              >İptal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="colorList"
            :items-per-page="10"
            class="elevation-1"
            :loading="loading"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Renk Listesi</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  label="Ara..."
                  class="mx-4"
                  solo
                  clearable
                ></v-text-field>
              </v-toolbar>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.title }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </MainLayout>
</template>

<script>
import { mapState } from "vuex";

import mainService from "@/services/mainService";
import MainLayout from "@/layouts/MainLayout.vue";

export default {
  name: "ColorList",
  components: {
    MainLayout,
  },
  created() {
    this.fetchColorList();
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: "Anasayfa",
          disabled: false,
          href: "pDashboard",
        },
        {
          title: "Renk İşlemleri",
          disabled: false,
          href: "",
        },
      ],
      headers: [{ title: "Adı", value: "name" }],
      select: { name: "Seçiniz", id: "0" },
      colorList: [],
      loading: false, // Yükleniyor durumu
      search: "", // Arama metni
      addColorDialog: false, // Kullanıcı ekleme modal durumu
      newColor: {
        // Yeni kullanıcı bilgileri
        name: "",
      },
      valid: false, // Form geçerliliği
      rules: {
        required: (value) => !!value || "Bu alan gereklidir.",
      },
    };
  },

  computed: {
    ...mapState(["Color"]), // Vuex state'inden Color'ı al
  },
  methods: {
    showAddColorDialog() {
      this.resetNewColor(); // Formu sıfırla
      this.addColorDialog = true; // Modalı göster
    },

    fetchColorList() {
      this.loading = true; // Yükleniyor durumunu başlat
      mainService
        .list("colors")
        .then((response) => {
          console.log(response);
          this.colorList = response; // Kullanıcı listesini güncelle
        })
        .catch((error) => {
          console.error("Bir hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false; // Yükleniyor durumunu bitir
        });
    },

    async addColor() {
      if (this.$refs.form.validate()) {
        // Formu doğrula
        try {
          await mainService.add(this.newColor); // Yeni kullanıcıyı ekle
          this.fetchColorList(); // Kullanıcı listesini güncelle
          this.addColorDialog = false; // Modalı kapat
          this.resetNewColor(); // Yeni kullanıcı formunu sıfırla
        } catch (error) {
          console.error("Kullanıcı eklenirken hata oluştu:", error);
        }
      }
    },

    resetNewColor() {
      this.newColor = {
        name: "",
      }; // Yeni kullanıcıyı sıfırla
    },
  },
};
</script>

<style scoped>
/* İsteğe bağlı stil ayarları */
.v-data-table {
  background-color: #ffffff;
  /* Beyaz arka plan */
  border-radius: 8px;
  /* Köşeleri yuvarla */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* Hafif gölge */
}

.icon-size {
  width: 30px;
  height: 30px;
}
</style>
